import angular from 'angular';
import AccountStatusComponent from './account-status-component';

export default angular
  .module('account-status', [])
  .component('accountStatus', new AccountStatusComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-status/account-status-module.js